import { NgModule } from '@angular/core';
import { UnAuthenticationRoutingModule } from './un-authentication-routing.module';
@NgModule({
  imports: [
     UnAuthenticationRoutingModule,
  ],
  providers: [
  ],
  declarations: [
  ],
  exports: [
  ]
})
export class UnAuthenticationModule { }

